export default "__VITE_ASSET__DTV0lKGU__"